import { useState } from "react";

export default function AccountTableSearchbar({ onSearch }) {
  const [searchTerm, setSearchTerm] = useState("");
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  }

  return (
    <div className="flex items-center gap-2">
      <form onSubmit={handleSubmit} className="relative w-[400px]">
        <div className="absolute inset-y-0 left-3 flex items-center">
          <button type="submit" className="hover:text-gray-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-400">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
          </button>
        </div>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full h-[42px] pl-10 pr-4 py-1 gap-2 rounded-full border border-[#64748B] bg-[#F8FAFC]"
        />
      </form>
      <button 
        onClick={() => {
          setSearchTerm("");
          onSearch("");
        }}
        className="hover:text-gray-600 focus:outline-none"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
      </button>
    </div>
  );
}